import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ILogEntryDrawerState {
    show: boolean;
    patientId?: number;
    appointmentId?: number;
    onLogEntrySave?: () => void;
}

export const initialStateLogEntryDrawer: ILogEntryDrawerState = {
    show: false,
    patientId: undefined,
    appointmentId: undefined,
    onLogEntrySave: undefined,
};

const logEntryDrawerSlice = createSlice({
    name: "logEntryDrawer",
    initialState: initialStateLogEntryDrawer,
    reducers: {
        showLogEntryDrawer: (state, action: PayloadAction<Omit<ILogEntryDrawerState, "show">>) => {
            return {
                patientId: undefined,
                appointmentId: undefined,
                onLogEntrySave: undefined,
                ...action.payload,
                show: true,
            };
        },
        hideLogEntryDrawer: () => initialStateLogEntryDrawer,
    },
});

export const { showLogEntryDrawer, hideLogEntryDrawer } = logEntryDrawerSlice.actions;
export default logEntryDrawerSlice.reducer;
